import { inject, Injectable } from '@angular/core';
import { CountriesResponseItem, ListCountriesGQL } from '@insolution/graphql-data-access';
import { firstValueFrom } from 'rxjs';
import { ELanguage } from '@insolution/shared-data-access';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  private listCountriesGQL = inject(ListCountriesGQL);

  public getCountries(language: ELanguage): Promise<CountriesResponseItem[]> {
    return firstValueFrom(this.listCountriesGQL.fetch({ language })).then((result) =>
      result.data.listCountries.slice().sort((a, b) => a.rank - b.rank)
    );
  }
}
